/** Link na sekciju početne stranice — radi i sa service stranica */
export function homeSectionTo(hash) {
  const id = hash.startsWith("#") ? hash : `#${hash}`;
  return { pathname: "/", hash: id };
}
